import type { FC } from 'react'

import type { ISiteRoom } from 'common/interfaces/ISiteRoom'

import { CartItem } from 'features/Cart/components/CartItem/CartItem'
import { CartError } from 'features/Cart/components/CartError/CartError'
import type { IOptionShopCartOption } from 'features/Option'
import { CartShopDay } from './CartShopDay'
import { CartShopDays } from './CartShopDays'
import { CartShopSlots } from './CartShopSlots'
import { CartShopRooms } from './CartShopRooms'

interface IProps {
  shopOption: IOptionShopCartOption
  handleEdit: (option: ISiteRoom) => void
  handleRemoveSlot: (roomId: number, slotId: number, day?: string) => void
  handleRemoveSlotsForDate: (date: string) => void
  handleRemoveEntireOption: () => void
  handleRemoveRoom: (roomId: number) => void
  handleRemoveDay: (date: string) => void
}

export const CartShopItem: FC<IProps> = ({
  handleEdit,
  handleRemoveSlot,
  handleRemoveSlotsForDate,
  handleRemoveEntireOption,
  handleRemoveRoom,
  handleRemoveDay,
  shopOption: { option, rooms, amount, day, days, slots, error_message },
}) => {
  const price =
    day?.price ??
    (days ? days.reduce((sum, d) => sum + d.price, 0) : 0) ??
    amount ??
    (slots ? slots.reduce((sum, s) => sum + s.price, 0) : 0)

  return (
    <CartItem
      price={price}
      key={option.id}
      name={option.name}
      handleEdit={() => handleEdit(option)}
      handleDelete={handleRemoveEntireOption}
      img={option.images.at(0)}>
      {day && <CartShopDay day={day} optionId={option.id} handleRemoveSlot={handleRemoveSlot} />}

      {days && days.length > 0 && (
        <CartShopDays
          days={days}
          handleRemoveEntireOption={handleRemoveEntireOption}
          handleRemoveDay={handleRemoveDay}
        />
      )}

      {slots && slots.length > 0 && (
        <CartShopSlots
          slots={slots}
          optionId={option.id}
          handleRemoveSlot={handleRemoveSlot}
          handleRemoveSlotsForDate={handleRemoveSlotsForDate}
          handleRemoveEntireOption={handleRemoveEntireOption}
        />
      )}

      {rooms && rooms.length > 0 && (
        <CartShopRooms
          rooms={rooms}
          handleRemoveSlot={handleRemoveSlot}
          handleRemoveSlotsForDate={handleRemoveSlotsForDate}
          handleRemoveRoom={handleRemoveRoom}
        />
      )}

      <CartError error={error_message} />
    </CartItem>
  )
}
